define('app/views/guest_success_register_form_view',['app/setup','app/views/helper'],
  function(
    takhfifan, helper
  ) {

  takhfifan.guestSuccessRegisterFormView = Backbone.View.extend({
    events: {
      'click .tkhGuestCustomerSubmit': 'register'
    },

    initialize: function() {
      var _this = this;

      takhfifan.eventHub.on('customer:login', function() {
        _this.$el.hide();
      }, this);

      takhfifan.eventHub.on('formkey', function(formKey) {
        _this.model.set('formKey', formKey);
      }, this);

      takhfifan.eventHub.on(
        'guestcustomer:registrationError',
        function(errors) {
          _this.renderErrors(errors);
          _this.enableForm();
        }, this);

      this.model.set('submitUrl', this.$el.data('url'));

      Backbone.Validation.bind(this);
      this._buttonContents = this.$(':submit').first().html();
    },

    register: function(e) {
      this.disableForm();
      this.clearMessages();
      e.preventDefault();
      var telephone = takhfifan.Helper.formatPhone(this.$('#telephone').val());

      var data = takhfifan.Helper.serializeToObject(this);

      // needed for validation of suburb and area fields, which depend on parents
      this.model.set(data, { validate: true });
      if (this.model.isValid()) {
        this.model.register();
        return true;
      } else {
        this.$('.alert-error').slideDown();
        this.enableForm();
      }
    },

    disableForm: function() {
      this.$(':submit').prop('disabled',true);
      this.$(':submit').empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    enableForm: function() {
      this.$(':submit').prop('disabled',false);
      this.$(':submit').empty().append(this._buttonContents);
    },

    renderErrors: function(errors) {
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var preFormattedError='<div class="alert alert-red"><span class="icon-info"></span><p>'+
          e
        '</p></div>';
        var $div = $('<div></div>');
        $div.html(preFormattedError);
        $errors.append($div);
      });
      $errors.show();
    },

    clearMessages: function() {
      this.$('.alert-error').empty();
    },

  });
});

